import Cookies from 'js-cookie'
import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { LOGOS } from './constants'

// 修改favicon
function changeFavicon(href) {
  let link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = href
  console.log(href);
  document.getElementsByTagName('head')[0].appendChild(link)
}

@Component
export default class TpAppNameMixins extends Vue {
  public tpAppName = Cookies.get('TP_AppName') || ''
  private get platformlogin() {
    return this.$store.state.platformlogin
  }
  public get tpAppLogo() {
    return this.tpAppName ? LOGOS[this.tpAppName] : undefined
  }

  @Watch('platformlogin')
  public onPlatformLogin() {
    this.tpAppName = Cookies.get('TP_AppName')
    if (this.tpAppName) {
      if (LOGOS[this.tpAppName]) {
        document.title = LOGOS[this.tpAppName].name
        changeFavicon(LOGOS[this.tpAppName].favicon)
      }
    }
  }

  public created() {
    this.tpAppName = Cookies.get('TP_AppName')
  }
}
